import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseTokenService } from './base-token.service';
import { AuthService } from '../../../api';
import { baseAuthSelectors, BaseCoreState } from '../../_store';
import { take, map } from 'rxjs/operators';
import { BaseTokenInterface } from '../../shared/interfaces/base-token-service.interface';
import { Store } from '@ngrx/store';

/* Required  query param: */
// ?loginAsUser=true

const LOGIN_AS_USER = 'loginAsUser';
/* Array of user emails that are allowed to log in as another user: */
export const ALLOWED_USER_EMAILS: string[] = [
  'schmidt.siegen+psp1@gmail.com',
  'schmidt.siegen+meier@gmail.com',
  'schmidt.siegen+dieArbeit@gmail.com',
  'bb@movepersonal.de',
  'engelke@lebensquelle.de',
  'samirad@smile.de',
  'admin1@customer1.com',
];

@Injectable({ providedIn: 'root' })
export class BaseLoginAsAnotherUserService {
  constructor(
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private baseTokenService: BaseTokenService,
    private authService: AuthService,
    private store: Store<BaseCoreState>
  ) {}

  loginAsAnotherUserIfPossible() {
    this.getUserInfo().subscribe((data) => {
      if (ALLOWED_USER_EMAILS.includes(data.email)) {
        this.replaceTokens(data);
      }
    });
  }

  private getUserInfo() {
    return this.store.select(baseAuthSelectors.getUserInfo).pipe(
      take(1),
      map((user) => user.data as BaseTokenInterface)
    );
  }

  private replaceTokens(data: BaseTokenInterface) {
    const isLoginAsUser = this.activatedRoute.snapshot.queryParamMap.get(LOGIN_AS_USER);
    let userEmail: string | null = '';

    if (isLoginAsUser === 'true') {
      userEmail = prompt("Enter the user's email:");

      if (userEmail) {
        this.authService
          .postAppApiAuthLoginasInvoke({
            body: {
              email: userEmail.trim(),
            },
          })
          .subscribe((value) => {
            this.baseTokenService.setTokens(value);
            const { [LOGIN_AS_USER]: _, ...remainingParams } = this.activatedRoute.snapshot.queryParams;

            this.router.navigate([], { queryParams: remainingParams }).then(() => {
              location.reload();
            });
          });
      }
    }
  }
}
